import { API, requestJson, requireResponse } from './http';
import { streamRequest } from './stream';

export const sessionRequest = (path, options = {}) => requestJson(`/admin${path}`, {
  credentials: 'include', ...options,
});

export function createAdminApi(csrfToken, onExpired) {
  const headers = { 'Content-Type': 'application/json', 'X-CSRF-Token': csrfToken || '' };
  const guarded = async operation => {
    try { return await operation(); }
    catch (error) { if (error.status === 401) onExpired(); throw error; }
  };
  return {
    get: (path, signal) => guarded(() => requestJson(path, { credentials: 'include', signal })),
    patch: (path, body, signal) => guarded(() => requestJson(path, { method: 'PATCH', credentials: 'include', headers, body: JSON.stringify(body), signal })),
    stream: (path, body, options) => guarded(() => streamRequest(path, body, { ...options, credentials: 'include', headers })),
    download: (path, signal) => guarded(async () => {
      const response = await requireResponse(await fetch(`${API}${path}`, { credentials: 'include', cache: 'no-store', signal }));
      return response.blob();
    }),
  };
}